import { Component, OnInit, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import { LdapUserDialPlanDetailsFieldConfig } from '../../../../shared/models/generated/ziroModels';
import { Observable, of } from 'rxjs';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';

export interface DnLdapDetailsFormEntity {
  e164Number: string;
  extension: string;
}

@Component({
  selector: 'ziro-directory-number-ldap-details-form',
  templateUrl: './directory-number-ldap-details-form.component.html',
  standalone: false,
})
export class ZiroDirectoryNumberLdapDetailsFormComponent
  extends ZiroFormAbstractDirective<DnLdapDetailsFormEntity, DnLdapDetailsFormEntity>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;

  readonly fieldConfig = input<LdapUserDialPlanDetailsFieldConfig>();

  formConfig: ZiroFormConfig;

  ngOnInit(): void {
    this._initFormConfig();
  }

  private _initFormConfig(): void {
    this.formConfig = {
      fields: {
        e164Number: {
          label: 'tkey;shared.dnWizard.dnDetails.ldapDetails.e_number.label',
          dataAutomation: 'dn-ldap-details-e164-number',
          hidden: () => !this.fieldConfig().e164Number.show,
          required: () => this.fieldConfig().e164Number.required,
          defaultValue: () => this.fieldConfig().e164Number.defaultValue,
        },
        extension: {
          label: 'tkey;shared.dnWizard.dnDetails.ldapDetails.extension.label',
          dataAutomation: 'dn-ldap-details-extension',
          hidden: () => !this.fieldConfig().extension.show,
          required: () => this.fieldConfig().extension.required,
          defaultValue: () => this.fieldConfig().extension.defaultValue,
        },
      },
    };
  }

  protected submit(): Observable<null> {
    return of(null);
  }
}
